import script from "./DetailsPhoto.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsPhoto.vue?vue&type=script&setup=true&lang=ts"

import "./DetailsPhoto.vue?vue&type=style&index=0&id=76dc3da0&lang=css"

const __exports__ = script;

export default __exports__